import { EnumBase } from 'hay-core-react';
class UsuarioEventoTipoEventoEnum extends EnumBase {
    constructor() {
        super([
            'main.usuarioevento.tipoevento.conexao',
            'main.usuarioevento.tipoevento.desconexao',
            'main.usuarioevento.tipoevento.registro',
            'main.usuarioevento.tipoevento.voucher',
            'main.usuarioevento.tipoevento.login',
            'main.usuarioevento.tipoevento.aniversario',
            'main.usuarioevento.tipoevento.pesquisaenviada',
            'main.usuarioevento.tipoevento.pesquisarespondida',
            'main.usuarioevento.tipoevento.pagamento',
            'main.usuarioevento.tipoevento.fidelizacao',
            'main.usuarioevento.tipoevento.limitenavegacaoatingido',
            'main.usuarioevento.tipoevento.recuperacaosenha',
        ]);
    }
}

const instance = new UsuarioEventoTipoEventoEnum();
export default instance;
